import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { AdministrativeTerritory } from '@cl/shared/models/administrative-territories/administrative-territory.model';

@Injectable({
    providedIn: 'root',
})
export class AdministrativeTerritoriesService extends BaseService<AdministrativeTerritory> {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/api/v1/administrative-territories');
    }
}
